import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { getInitials } from "../../util/PlayerText";

// A player beside the board: avatar with initials and online status, name, a line of details and their clock.
// The player to move is ringed. Aligned to the right, everything is mirrored.
const PlayerCard: FunctionComponent<{
    name: string,
    isGuest: boolean,
    details: string,
    active: boolean,
    online?: boolean,
    clock?: React.ReactNode,
    alignRight?: boolean,
}> = ({ name, isGuest, details, active, online, clock, alignRight }) => {
    const { t } = useTranslation();
    return (
        <div className={"pl" + (active ? " on" : "") + (alignRight ? " r" : "")}>
            <div className="av" aria-hidden="true">
                {getInitials(name, isGuest)}
                {online !== undefined && <span className={"presence" + (online ? " online" : "")} />}
            </div>
            <div className="pinfo">
                <div className="pname">{name}</div>
                <div className="psub">
                    {details}
                    {online !== undefined && <span className="visually-hidden">{` · ${online ? t("Online") : t("Offline")}`}</span>}
                </div>
            </div>
            {clock}
        </div>
    );
};

export default PlayerCard;
